import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef,
} from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  Snackbar,
  Alert,
  AlertTitle,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ModuleRegistry } from "@ag-grid-community/core";
import { AgGridReact } from "@ag-grid-community/react";
import { AG_GRID_LOCALE_ES } from "@ag-grid-community/locale";
import { ClipboardModule } from "@ag-grid-enterprise/clipboard";
import { RangeSelectionModule } from "@ag-grid-enterprise/range-selection";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { MultiFilterModule } from "@ag-grid-enterprise/multi-filter";
import { MenuModule } from "@ag-grid-enterprise/menu";
import { FiltersToolPanelModule } from "@ag-grid-enterprise/filter-tool-panel";
import { MasterDetailModule } from "@ag-grid-enterprise/master-detail";
import { ColumnsToolPanelModule } from "@ag-grid-enterprise/column-tool-panel";
import { CsvExportModule } from "@ag-grid-community/csv-export";
import { ExcelExportModule } from "@ag-grid-enterprise/excel-export";
import { SetFilterModule } from "@ag-grid-enterprise/set-filter";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import DownloadIcon from "@mui/icons-material/Download";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import FullscreenIcon from "@mui/icons-material/Fullscreen";

import {
  BreadCrumbs,
  ButtonAction,
  CardHeaderWidget,
  LoadingWidget,
  SaveAction,
  SearchBasicSelect,
  SelectMultipleWidget2,
  TextFieldWidgetDateController2,
} from "../../../components";
import { alterArrayAddLabels, dashAdd } from "../../../helpers";
import { FormPrompt } from "../../../helpers/FormPrompt";

import { BsContainer, BsRow, BsCol } from "../../../layouts/components";
import viewsTexts from "../../../common/viewsTexts.json";
import { AxiosContext } from "../../../context/AxiosContext";
import { Context } from "../../../context/Context";
import { useForm } from "react-hook-form";
import { SEASONS_MOCK } from "helpers/Mockups";
import YIELD_DATA from "../yieldcalculatorData.json";
// import { formatters, validators } from '../formatter_validator';
import "../styles.css";
import { numberFormatter } from "helpers/functionHelpers";
import { formatters, validators, FIELDS } from "../fieldsConfig";
import { FiltersContext } from "../../../context";
import {
  createColumnDef,
  handleCellValueChanged,
  handleChangeCellClipboard,
} from "../agGridHelpers";

const useStyles = makeStyles((theme) => ({
  tableContainerStyle: {
    [theme.breakpoints.up("sm")]: {
      paddingRight: 34,
    },
  },
  selectStyle: {
    marginTop: 0,
    marginBottom: 0,
  },
  divider: {
    height: "28px",
    margin: "4px",
  },
  iconButton: {
    padding: "8px",
  },
  actionColumn: {
    display: "flex",
    justifyContent: "flex-start",
    width: "100%",
  },
}));

ModuleRegistry.registerModules([
  FiltersToolPanelModule,
  ClientSideRowModelModule,
  RangeSelectionModule,
  MenuModule,
  MultiFilterModule,
  MasterDetailModule,
  ColumnsToolPanelModule,
  CsvExportModule,
  ExcelExportModule,
  SetFilterModule,
  ClipboardModule,
]);

const endPointFilterName = "v1/collection-bd/filter";
const endPointName = "v1/collection-bd/yield-calculator";
const endPointNamePost = "v1/collection-bd/yield-calculator/create";

const titleModule = "Yield Calculator";

const YieldCalculator = () => {
  const theme = useTheme();

  const axiosContext = useContext(AxiosContext);

  const { userId, userHuerto, userName, userOrchard } = useContext(Context);

  const [filterOptionsState, setFilterOptionsState] = useState(null);

  const { state: filterState, addFilter } = useContext(FiltersContext);

  const gridApiRef = useRef(null);

  const onGridReady = (params) => {
    gridApiRef.current = params.api;
    params.api.sizeColumnsToFit();
  };

  const localeText = AG_GRID_LOCALE_ES;

  const {
    client_filter,
    orchard_filter,
    season_since_filter,
    season_until_filter,
  } = filterState;

  // TABLA
  const [confirmPromptState, setConfirmPromptState] = useState(false);

  const [tableContainerStyleState, setTableContainerStyleState] = useState({
    // height: '80vh',
    width: "100%",
    minHeight: 800,
  });

  const [tableStyleState, setTableStyleState] = useState({
    height: 700,
  });

  const [fullScreenState, setFullScreenState] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);

  const [visibleColumnsState, setVisibleColumnsState] = useState([]);

  const [titleCheckState, setTitleCheckState] = useState(
    "Estimación Diaria Confirmada"
  );

  const [copyButtonState, setCopyButtonState] = useState(false);

  const [rowData, setRowData] = useState([]);
  const paginationPageSizeSelector = [20, 50, 100, 500, 1000];

  const [quickFilterText, setQuickFilterText] = useState(""); // estado para el filtro de busquedageneral

  const [dataTableState, setDataTableState] = useState([]);

  const [loadingSubmitFilterState, setLoadingSubmitFilterState] =
    useState(false);

  const [loadingSubmitState, setLoadingSubmitState] = useState(false);

  const [loadingFilterDataState, setLoadingFilterDataState] = useState(false);

  const [clientOptionsState, setClientOptionsState] = useState([]);

  const [successSubmitState, setSuccessSubmitState] = useState(false);

  const [orchardsOptionsState, setOrchardsOptionsState] = useState([]);

  const [seasonOptionsState, setSeasonOptionsState] = useState([]);

  const [openDialogState, setOpenDialogState] = useState(false);

  const [noMessageKilosState, setNoMessageKilosState] = useState(false);

  const [openWarningState, setOpenWarningState] = useState(false);
  const [openErrorState, setOpenErrorState] = useState(false);
  const [errorDataState, setErrorDataState] = useState(null);

  const {
    handleSubmit,
    control,
    watch,
    setValue,
    setError,
    reset,
    clearErrors,
    getValues,
    formState: { errors },
  } = useForm();

  // crear un ref de alert
  const alertRef = useRef(false);

  const classes = useStyles();

  const handleClickOpenDialog = () => {
    setOpenDialogState(true);
  };

  const watchClient = watch("client", "");
  const watchOrchard = watch("orchard", "");
  const watchSince = watch("seasonSince", "");
  const watchUntil = watch("seasonUntil", "");

  useEffect(() => {
    clearErrors("incorrectDates");
  }, [watchSince, watchUntil]);

  const onSubmit = async (values) => {
    if (alertRef.current) {
      handleClickOpenDialog();
      return;
    }

    setNoMessageKilosState(false);

    const seasonBeginFormat = values?.seasonSince?.value;
    // const seasonEndFormat = seasonFormatIso(seasonEnd);
    const seasonEndFormat = values?.seasonUntil?.value;

    if (seasonBeginFormat > seasonEndFormat) {
      // console.log(dateBeginFormat, dateEndFormat, '<<<<<------------');
      setError("incorrectDates", {
        type: "manual",
        message: "Fecha hasta debe ser mayor a desde",
      });
      return;
    }

    setDataTableState([]);
    setLoadingSubmitFilterState(true);

    const dataQuery = {
      clientValue: values.client.value,
      orchardValue: values.orchard.value,
      seasonSince: seasonBeginFormat,
      seasonUntil: seasonEndFormat,
    };

    // console.log(dataQuery, "<<<<<-------------------dataQuery");

    // const data = YIELD_DATA;

    // // MOCKS
    // setDataTableState(data);

    // setVisibleColumnsState(finalColumns);

    // const rowDataFullTransform = processDataRowDetailFull(data);

    // setRowData(rowDataFullTransform);

    // setLoadingSubmitFilterState(false);

    addFilter({
      orchard_filter: values.orchard.value,
      client_filter: values.client.value,
      season_since_filter: seasonBeginFormat,
      season_until_filter: seasonEndFormat,
    });

    try {
      const response = await axiosContext.authAxios.post(
        endPointName,
        dataQuery
      );

      const { data, status } = response;

      // console.log(data, '<<<<<-------------------', paramsQuery);

      if (status === 200) {
        setDataTableState(data);

        setVisibleColumnsState(finalColumns);

        const rowDataFullTransform = processDataRowDetailFull(data);

        setRowData(rowDataFullTransform);
      }
    } catch (error) {
    } finally {
      setLoadingSubmitFilterState(false);
    }
  };

  const handleQuickFilterChange = (event) => {
    setQuickFilterText(event.target.value);
  };

  const clearFocusSelection = () => {
    if (gridApiRef.current && gridApiRef.current) {
      gridApiRef.current.clearFocusedCell();
    }

    // console.log('1-clearFocusSelection');

    setConfirmPromptState(true);
  };

  // procesa las filas con su detalle histórico
  const processDataRowDetailFull = (data) => {
    // const { table } = data;
    const rows = [];

    data.forEach((item) => {
      const row = {
        id: `${item.id}_${item.idUnitProductive}`,
        client: item.client,
        clientValue: item.clientValue,
        season: item?.season,
        specie: item.specie,
        specieValue: item.specieValue,
        agroBusiness: item.agroBusiness,
        agroBusinessValue: item.agroBusinessValue,
        orchard: item.orchard,
        orchardValue: item.orchardValue,
        variety: item.variety,
        varietyValue: item.varietyValue,
        idUnitProductive: item.idUnitProductive,
        cc: item.cc,
        ccValue: item.ccValue,
        quarter: item.quarter,
        quarterValue: item.quarterValue,
        rootStock: item.rootStock,
        rootStockValue: item.rootStockValue,
        arms: item.arms,
        dartPrePoda: item.dartPrePoda,
        dartPostPoda: item.dartPostPoda,
        twigPrePoda: item.twigPrePoda,
        twigPostPoda: item.twigPostPoda,
        flowersDart: item.flowersDart,
        budDart: item.budDart,
        disbudding: item.disbudding,
        flowersTwig: item.flowersTwig,
        frostDart: item.frostDart,
        frostTwig: item.frostTwig,
        fruitsDartMax: item.fruitsDartMax,
        fruitDropRateObjective: item.fruitDropRateObjective,
        fruitsetEstimate: item.fruitsetEstimate,
        yieldKilosTarget: item.yieldKilosTarget,
        boxHaReal: item.boxHaReal,
        exportPercentageReal: item.exportPercentageReal,
        fruitsPlantPreRaleo: item.fruitsPlantPreRaleo,
        fruitsPlantPreRaleoExcel: item.fruitsPlantPreRaleoExcel,
        fruitsPlantPostRaleo: item.fruitsPlantPostRaleo,
        fruitsPlantPostRaleoExcel: item.fruitsPlantPostRaleoExcel,
        guidelineThinning: item.guidelineThinning,
        caliberEstimate: item.caliberEstimate,
        caliberReal: item.caliberReal,
        yieldReal: item.yieldReal,
        dateEndHarvest: item.dateEndHarvest,
        dateStartHarvest: item.dateStartHarvest,
        dartPrePodaExcel: item.dartPrePodaExcel,
        dartPostPodaExcel: item.dartPostPodaExcel,
        twigPrePodaExcel: item.twigPrePodaExcel,
        twigPostPodaExcel: item.twigPostPodaExcel,
        brindillaPrePoda: item.brindillaPrePoda,
        brindillaPostPoda: item.brindillaPostPoda,
        brindillaPrePodaExcel: item.brindillaPrePodaExcel,
        brindillaPostPodaExcel: item.brindillaPostPodaExcel,
        flowersBrindilla: item.flowersBrindilla,
        twigObjective: item.twigObjective,
        caliberObjective: item.caliberObjective,
        boxHaObjective: item.boxHaObjective,
        fruitsTwigObjective: item.fruitsTwigObjective,
        plantsHaProductive: item.plantsHaProductive,
        exportPercentageEstimate: item.exportPercentageEstimate,
        finalChargesPrePoda: item.finalChargesPrePoda,
        finalChargesPostPoda: item.finalChargesPostPoda,
        finalChargesPostAmarre: item.finalChargesPostAmarre,
        finalChargesPrePodaExcel: item.finalChargesPrePodaExcel,
        finalChargesPostPodaExcel: item.finalChargesPostPodaExcel,
        finalChargesPostAmarreExcel: item.finalChargesPostAmarreExcel,
        finalBudPrePoda: item.finalBudPrePoda,
        finalBudPostPoda: item.finalBudPostPoda,
        finalBudPostAmarre: item.finalBudPostAmarre,
        finalBudPrePodaExcel: item.finalBudPrePodaExcel,
        finalBudPostPodaExcel: item.finalBudPostPodaExcel,
        finalBudPostAmarreExcel: item.finalBudPostAmarreExcel,
        caliberObjectiveEquivalent: item.caliberObjectiveEquivalent,
        caliberRealEquivalent: item.caliberRealEquivalent,
        budSproutsReal: item.budSproutsReal,
        budSetReal: item.budSetReal,
        fertilityReal: item.fertilityReal,
        budSproutsObjective: item.budSproutsObjective,
        budSetObjective: item.budSetObjective,
        fertilityObjective: item.fertilityObjective,
        productionCoeffObjective: item.productionCoeffObjective,
        productionCoeffReal: item.productionCoeffReal,
        yieldSeek: item.yieldSeek,
        frostDamage: item.frostDamage,
        countPlantsBrotacion: item.countPlantsBrotacion,
        countQuadrantBrotacion: item.countQuadrantBrotacion,
        sproutsPlantBrotacion: item.sproutsPlantBrotacion,
        sproutsQuadrantBrotacion: item.sproutsQuadrantBrotacion,
        finalSproutsBrotacion: item.finalSproutsBrotacion,
        sproutsWithFruitQuadrantBoton: item.sproutsWithFruitQuadrantBoton,
        sproutsWithFruitPlantBoton: item.sproutsWithFruitPlantBoton,
        finalSproutsWithFruitBoton: item.finalSproutsWithFruitBoton,
        countQuadrantSproutsWithOutFruitBoton: item.countQuadrantSproutsWithOutFruitBoton,
        countPlantsSproutsWithOutFruitBoton: item.countPlantsSproutsWithOutFruitBoton,
        finalSproutsWithOutFruitBoton: item.finalSproutsWithOutFruitBoton,
        sproutsBrotacionHa: item.sproutsBrotacionHa,
        countQuadrantBoton: item.countQuadrantBoton,
        countPlantsBoton: item.countPlantsBoton,
        buttonQuadrantBoton: item.buttonQuadrantBoton,
        buttonPlantBoton: item.buttonPlantBoton,
        finalButtonBoton: item.finalButtonBoton,
        buttonSimpleQuadrantBoton: item.buttonSimpleQuadrantBoton,
        buttonArmQuadrantBoton: item.buttonArmQuadrantBoton,
        buttonDeformedQuadrantBoton: item.buttonDeformedQuadrantBoton,
        buttonSimplePlantBoton: item.buttonSimplePlantBoton,
        buttonArmPlantBoton: item.buttonArmPlantBoton,
        buttonDeformedPlantBoton: item.buttonDeformedPlantBoton,
        finalButtonSimpleBoton: item.finalButtonSimpleBoton,
        finalButtonArmBoton: item.finalButtonArmBoton,
        finalButtonDeformedBoton: item.finalButtonDeformedBoton,
        buttonBotonHa: item.buttonBotonHa,
        finalFruitFormedFrutoFormado: item.finalFruitFormedFrutoFormado,
      };

      rows.push(row);
    });
    // console.log(rows, '<<<<<--------------rowsTable');

    return rows;
  };

  const resetFilters = () => {
    if (gridApiRef && gridApiRef.current) {
      gridApiRef.current.setFilterModel(null);
      gridApiRef.current.resetColumnState();
    }
  };

  const handleClickAlert = (type, errorData) => {
    if (type === "warning") {
      setErrorDataState(errorData);
      setOpenWarningState(true);
    } else {
      setErrorDataState(errorData);
      setOpenErrorState(true);
    }
  };

  const handleCloseWarningAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenWarningState(false);
    setErrorDataState(null);
  };

  const handleCloseErrorAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorState(false);
    setErrorDataState(null);
  };

  const finalColumns = [
    {
      colId: "caracter",
      // headerGroup: 'caracter',
      headerName: "Caracterización",
      children: [
        {
          headerName: "ID Unidad Productiva",
          field: "idUnitProductive",
          editable: false,
          suppressFillHandle: true,
          filter: "agMultiColumnFilter",
          suppressMovable: true,
          // rowGroup: false,
          enableRowGroup: true,
          filterParams: {
            filters: [
              {
                filter: "agTextColumnFilter",
                filterParams: {
                  defaultOption: "contains",
                  filterOptions: ["contains"],
                },
              },
              {
                filter: "agSetColumnFilter",
                filterParams: {
                  suppressMiniFilter: true,
                },
              },
            ],
          },
        },
        {
          headerName: "Cliente",
          field: "client",
          editable: false,
          suppressFillHandle: true,
          filter: "agMultiColumnFilter",
          suppressMovable: true,
          // rowGroup: false,
          enableRowGroup: true,
          filterParams: {
            filters: [
              {
                filter: "agTextColumnFilter",
                filterParams: {
                  defaultOption: "contains",
                  filterOptions: ["contains"],
                },
              },
              {
                filter: "agSetColumnFilter",
                filterParams: {
                  suppressMiniFilter: true,
                },
              },
            ],
          },
        },
        {
          headerName: "Agricola",
          field: "agroBusiness",
          editable: false,
          suppressFillHandle: true,
          filter: "agMultiColumnFilter",
          suppressMovable: true,
          // rowGroup: false,
          enableRowGroup: true,
          filterParams: {
            filters: [
              {
                filter: "agTextColumnFilter",
                filterParams: {
                  defaultOption: "contains",
                  filterOptions: ["contains"],
                },
              },
              {
                filter: "agSetColumnFilter",
                filterParams: {
                  suppressMiniFilter: true,
                },
              },
            ],
          },
        },
        {
          headerName: "Huerto",
          field: "orchard",
          editable: false,
          suppressFillHandle: true,
          filter: "agMultiColumnFilter",
          suppressMovable: true,
          // rowGroup: false,
          enableRowGroup: true,
          hide: false,
          filterParams: {
            filters: [
              {
                filter: "agTextColumnFilter",
                filterParams: {
                  defaultOption: "contains",
                  filterOptions: ["contains"],
                },
              },
              {
                filter: "agSetColumnFilter",
                filterParams: {
                  suppressMiniFilter: true,
                },
              },
            ],
          },
        },
        {
          headerName: "CC",
          field: "cc",
          editable: false,
          suppressFillHandle: true,
          filter: "agMultiColumnFilter",
          suppressMovable: true,
          // rowGroup: false,
          enableRowGroup: true,
          filterParams: {
            filters: [
              {
                filter: "agTextColumnFilter",
                filterParams: {
                  defaultOption: "contains",
                  filterOptions: ["contains"],
                },
              },
              {
                filter: "agSetColumnFilter",
                filterParams: {
                  suppressMiniFilter: true,
                },
              },
            ],
          },
        },
        {
          headerName: "Cuartel",
          field: "quarter",
          editable: false,
          suppressFillHandle: true,
          filter: "agMultiColumnFilter",
          suppressMovable: true,
          // rowGroup: false,
          enableRowGroup: true,
          filterParams: {
            filters: [
              {
                filter: "agTextColumnFilter",
                filterParams: {
                  defaultOption: "contains",
                  filterOptions: ["contains"],
                },
              },
              {
                filter: "agSetColumnFilter",
                filterParams: {
                  suppressMiniFilter: true,
                },
              },
            ],
          },
        },
        {
          headerName: "Especie",
          field: "specie",
          editable: false,
          suppressFillHandle: true,
          filter: "agMultiColumnFilter",
          suppressMovable: true,
          filterParams: {
            filters: [
              {
                filter: "agTextColumnFilter",
                filterParams: {
                  defaultOption: "contains",
                  filterOptions: ["contains"],
                },
              },
              {
                filter: "agSetColumnFilter",
                filterParams: {
                  suppressMiniFilter: true,
                },
              },
            ],
          },
        },
        {
          headerName: "Variedad",
          field: "variety",
          editable: false,
          filter: "agMultiColumnFilter",
          suppressMovable: true,
          // rowGroup: false,
          enableRowGroup: true,
          filterParams: {
            filters: [
              {
                filter: "agTextColumnFilter",
                filterParams: {
                  defaultOption: "contains",
                  filterOptions: ["contains"],
                },
              },
              {
                filter: "agSetColumnFilter",
                filterParams: {
                  suppressMiniFilter: true,
                },
              },
            ],
          },
          suppressFillHandle: true,
        },
        {
          headerName: "Portainjerto",
          field: "rootStock",
          editable: false,
          suppressFillHandle: true,
          filter: "agMultiColumnFilter",
          suppressMovable: true,
          // rowGroup: false,
          enableRowGroup: true,
          filterParams: {
            filters: [
              {
                filter: "agTextColumnFilter",
                filterParams: {
                  defaultOption: "contains",
                  filterOptions: ["contains"],
                },
              },
              {
                filter: "agSetColumnFilter",
                filterParams: {
                  suppressMiniFilter: true,
                },
              },
            ],
          },
        },
        {
          headerName: "Temporadas",
          field: "season",
          editable: false,
          suppressFillHandle: true,
          filter: "agMultiColumnFilter",
          suppressMovable: true,
          // rowGroup: false,
          enableRowGroup: true,
          filterParams: {
            filters: [
              {
                filter: "agTextColumnFilter",
                filterParams: {
                  defaultOption: "contains",
                  filterOptions: ["contains"],
                },
              },
              {
                filter: "agSetColumnFilter",
                filterParams: {
                  suppressMiniFilter: true,
                },
              },
            ],
          },
        },
      ],
    },
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.ARMS.headerName,
      field: FIELDS.YIELD_CALCULATOR.ARMS.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.DART_PRE_PODA.headerName,
      field: FIELDS.YIELD_CALCULATOR.DART_PRE_PODA.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
      editValueSetterExcel: false,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.DART_PRE_PODA_EXCEL.headerName,
      field: FIELDS.YIELD_CALCULATOR.DART_PRE_PODA_EXCEL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
      editValueSetterExcel: false,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.DART_POST_PODA.headerName,
      field: FIELDS.YIELD_CALCULATOR.DART_POST_PODA.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
      editValueSetterExcel: false,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.DART_POST_PODA_EXCEL.headerName,
      field: FIELDS.YIELD_CALCULATOR.DART_POST_PODA_EXCEL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
      editValueSetterExcel: false,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.TWIG_PRE_PODA.headerName,
      field: FIELDS.YIELD_CALCULATOR.TWIG_PRE_PODA.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
      editValueSetterExcel: false,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.TWIG_PRE_PODA_EXCEL.headerName,
      field: FIELDS.YIELD_CALCULATOR.TWIG_PRE_PODA_EXCEL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
      editValueSetterExcel: false,
    }),

    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.TWIG_POST_PODA.headerName,
      field: FIELDS.YIELD_CALCULATOR.TWIG_POST_PODA.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
      editValueSetterExcel: false,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.TWIG_POST_PODA_EXCEL.headerName,
      field: FIELDS.YIELD_CALCULATOR.TWIG_POST_PODA_EXCEL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
      editValueSetterExcel: false,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BRINDILLA_PRE_PODA.headerName,
      field: FIELDS.YIELD_CALCULATOR.BRINDILLA_PRE_PODA.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BRINDILLA_PRE_PODA_EXCEL.headerName,
      field: FIELDS.YIELD_CALCULATOR.BRINDILLA_PRE_PODA_EXCEL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BRINDILLA_POST_PODA.headerName,
      field: FIELDS.YIELD_CALCULATOR.BRINDILLA_POST_PODA.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BRINDILLA_POST_PODA_EXCEL.headerName,
      field: FIELDS.YIELD_CALCULATOR.BRINDILLA_POST_PODA_EXCEL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.FLOWERS_BRINDILLA.headerName,
      field: FIELDS.YIELD_CALCULATOR.FLOWERS_BRINDILLA.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BUD_DART.headerName,
      field: FIELDS.YIELD_CALCULATOR.BUD_DART.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.CALIBER_OBJECTIVE.headerName,
      field: FIELDS.YIELD_CALCULATOR.CALIBER_OBJECTIVE.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName:
        FIELDS.YIELD_CALCULATOR.CALIBER_OBJECTIVE_EQUIVALENT.headerName,
      field: FIELDS.YIELD_CALCULATOR.CALIBER_OBJECTIVE_EQUIVALENT.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.CALIBER_ESTIMATE.headerName,
      field: FIELDS.YIELD_CALCULATOR.CALIBER_ESTIMATE.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.CALIBER_REAL.headerName,
      field: FIELDS.YIELD_CALCULATOR.CALIBER_REAL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.CALIBER_REAL_EQUIVALENT.headerName,
      field: FIELDS.YIELD_CALCULATOR.CALIBER_REAL_EQUIVALENT.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.DISBUDDING.headerName,
      field: FIELDS.YIELD_CALCULATOR.DISBUDDING.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.FLOWERS_DART.headerName,
      field: FIELDS.YIELD_CALCULATOR.FLOWERS_DART.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.FLOWERS_TWIG.headerName,
      field: FIELDS.YIELD_CALCULATOR.FLOWERS_TWIG.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.FROST_DART.headerName,
      field: FIELDS.YIELD_CALCULATOR.FROST_DART.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.FROST_TWIG.headerName,
      field: FIELDS.YIELD_CALCULATOR.FROST_TWIG.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.FRUITS_PLANT_PRE_RALEO.headerName,
      field: FIELDS.YIELD_CALCULATOR.FRUITS_PLANT_PRE_RALEO.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
      editValueSetterExcel: false,
    }),
    createColumnDef({
      headerName:
        FIELDS.YIELD_CALCULATOR.FRUITS_PLANT_PRE_RALEO_EXCEL.headerName,
      field: FIELDS.YIELD_CALCULATOR.FRUITS_PLANT_PRE_RALEO_EXCEL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
      editValueSetterExcel: false,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.FRUITS_PLANT_POST_RALEO.headerName,
      field: FIELDS.YIELD_CALCULATOR.FRUITS_PLANT_POST_RALEO.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
      editValueSetterExcel: false,
    }),
    createColumnDef({
      headerName:
        FIELDS.YIELD_CALCULATOR.FRUITS_PLANT_POST_RALEO_EXCEL.headerName,
      field: FIELDS.YIELD_CALCULATOR.FRUITS_PLANT_POST_RALEO_EXCEL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
      editValueSetterExcel: false,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.FRUITSET_ESTIMATE.headerName,
      field: FIELDS.YIELD_CALCULATOR.FRUITSET_ESTIMATE.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.FRUIT_DROP_RATE_OBJECTIVE.headerName,
      field: FIELDS.YIELD_CALCULATOR.FRUIT_DROP_RATE_OBJECTIVE.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.YIELD_KILOS_TARGET.headerName,
      field: FIELDS.YIELD_CALCULATOR.YIELD_KILOS_TARGET.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BOX_HA_REAL.headerName,
      field: FIELDS.YIELD_CALCULATOR.BOX_HA_REAL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.EXPORT_PERCENTAGE_REAL.headerName,
      field: FIELDS.YIELD_CALCULATOR.EXPORT_PERCENTAGE_REAL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.GUIDELINE_THINNING.headerName,
      field: FIELDS.YIELD_CALCULATOR.GUIDELINE_THINNING.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.YIELD_REAL.headerName,
      field: FIELDS.YIELD_CALCULATOR.YIELD_REAL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.DATE_START_HARVEST.headerName,
      field: FIELDS.YIELD_CALCULATOR.DATE_START_HARVEST.field,
      dataType: "text",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.DATE_END_HARVEST.headerName,
      field: FIELDS.YIELD_CALCULATOR.DATE_END_HARVEST.field,
      dataType: "text",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.TWIG_OBJECTIVE.headerName,
      field: FIELDS.YIELD_CALCULATOR.TWIG_OBJECTIVE.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BOX_HA_OBJECTIVE.headerName,
      field: FIELDS.YIELD_CALCULATOR.BOX_HA_OBJECTIVE.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.FRUITS_TWIG_OBJECTIVE.headerName,
      field: FIELDS.YIELD_CALCULATOR.FRUITS_TWIG_OBJECTIVE.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.PLANTS_HA_PRODUCTIVE.headerName,
      field: FIELDS.YIELD_CALCULATOR.PLANTS_HA_PRODUCTIVE.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.EXPORT_PERCENTAGE_ESTIMATE.headerName,
      field: FIELDS.YIELD_CALCULATOR.EXPORT_PERCENTAGE_ESTIMATE.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.CHARGES_PRE_PODA.headerName,
      field: FIELDS.YIELD_CALCULATOR.CHARGES_PRE_PODA.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.CHARGES_PRE_PODA_EXCEL.headerName,
      field: FIELDS.YIELD_CALCULATOR.CHARGES_PRE_PODA_EXCEL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.CHARGES_POST_PODA.headerName,
      field: FIELDS.YIELD_CALCULATOR.CHARGES_POST_PODA.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.CHARGES_POST_PODA_EXCEL.headerName,
      field: FIELDS.YIELD_CALCULATOR.CHARGES_POST_PODA_EXCEL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.CHARGES_POST_AMARRE.headerName,
      field: FIELDS.YIELD_CALCULATOR.CHARGES_POST_AMARRE.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.CHARGES_POST_AMARRE_EXCEL.headerName,
      field: FIELDS.YIELD_CALCULATOR.CHARGES_POST_AMARRE_EXCEL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BUD_PRE_PODA.headerName,
      field: FIELDS.YIELD_CALCULATOR.BUD_PRE_PODA.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BUD_PRE_PODA_EXCEL.headerName,
      field: FIELDS.YIELD_CALCULATOR.BUD_PRE_PODA_EXCEL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BUD_POST_PODA.headerName,
      field: FIELDS.YIELD_CALCULATOR.BUD_POST_PODA.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BUD_POST_PODA_EXCEL.headerName,
      field: FIELDS.YIELD_CALCULATOR.BUD_POST_PODA_EXCEL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BUD_POST_AMARRE.headerName,
      field: FIELDS.YIELD_CALCULATOR.BUD_POST_AMARRE.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BUD_POST_AMARRE_EXCEL.headerName,
      field: FIELDS.YIELD_CALCULATOR.BUD_POST_AMARRE_EXCEL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BUD_SPROUTS_REAL.headerName,
      field: FIELDS.YIELD_CALCULATOR.BUD_SPROUTS_REAL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BUD_SET_REAL.headerName,
      field: FIELDS.YIELD_CALCULATOR.BUD_SET_REAL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.FERTILITY_REAL.headerName,
      field: FIELDS.YIELD_CALCULATOR.FERTILITY_REAL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BUD_SPROUTS_OBJECTIVE.headerName,
      field: FIELDS.YIELD_CALCULATOR.BUD_SPROUTS_OBJECTIVE.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BUD_SET_OBJECTIVE.headerName,
      field: FIELDS.YIELD_CALCULATOR.BUD_SET_OBJECTIVE.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.FERTILITY_OBJECTIVE.headerName,
      field: FIELDS.YIELD_CALCULATOR.FERTILITY_OBJECTIVE.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.PRODUCTION_COEFF_OBJECTIVE.headerName,
      field: FIELDS.YIELD_CALCULATOR.PRODUCTION_COEFF_OBJECTIVE.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.PRODUCTION_COEFF_REAL.headerName,
      field: FIELDS.YIELD_CALCULATOR.PRODUCTION_COEFF_REAL.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.FROST_DAMAGE.headerName,
      field: FIELDS.YIELD_CALCULATOR.FROST_DAMAGE.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.YIELD_SEEK.headerName,
      field: FIELDS.YIELD_CALCULATOR.YIELD_SEEK.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BUTTON_BOTON_HA.headerName,
      field: FIELDS.YIELD_CALCULATOR.BUTTON_BOTON_HA.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.COUNT_PLANTS_BROTACION.headerName,
      field: FIELDS.YIELD_CALCULATOR.COUNT_PLANTS_BROTACION.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.COUNT_QUADRANT_BROTACION.headerName,
      field: FIELDS.YIELD_CALCULATOR.COUNT_QUADRANT_BROTACION.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.SPROUTS_PLANT_BROTACION.headerName,
      field: FIELDS.YIELD_CALCULATOR.SPROUTS_PLANT_BROTACION.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.SPROUTS_QUADRANT_BROTACION.headerName,
      field: FIELDS.YIELD_CALCULATOR.SPROUTS_QUADRANT_BROTACION.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.FINAL_SPROUTS_BROTACION.headerName,
      field: FIELDS.YIELD_CALCULATOR.FINAL_SPROUTS_BROTACION.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.SPROUTS_WITH_FRUIT_QUADRANT_BOTON.headerName,
      field: FIELDS.YIELD_CALCULATOR.SPROUTS_WITH_FRUIT_QUADRANT_BOTON.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.SPROUTS_WITH_FRUIT_PLANT_BOTON.headerName,
      field: FIELDS.YIELD_CALCULATOR.SPROUTS_WITH_FRUIT_PLANT_BOTON.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.FINAL_SPROUTS_WITH_FRUIT_BOTON.headerName,
      field: FIELDS.YIELD_CALCULATOR.FINAL_SPROUTS_WITH_FRUIT_BOTON.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.COUNT_QUADRANT_SPROUTS_WITH_OUT_FRUIT_BOTON.headerName,
      field: FIELDS.YIELD_CALCULATOR.COUNT_QUADRANT_SPROUTS_WITH_OUT_FRUIT_BOTON.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.COUNT_PLANTS_SPROUTS_WITH_OUT_FRUIT_BOTON.headerName,
      field: FIELDS.YIELD_CALCULATOR.COUNT_PLANTS_SPROUTS_WITH_OUT_FRUIT_BOTON.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.FINAL_SPROUTS_WITH_OUT_FRUIT_BOTON.headerName,
      field: FIELDS.YIELD_CALCULATOR.FINAL_SPROUTS_WITH_OUT_FRUIT_BOTON.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.SPROUTS_BROTACION_HA.headerName,
      field: FIELDS.YIELD_CALCULATOR.SPROUTS_BROTACION_HA.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.COUNT_QUADRANT_BOTON.headerName,
      field: FIELDS.YIELD_CALCULATOR.COUNT_QUADRANT_BOTON.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.COUNT_PLANTS_BOTON.headerName,
      field: FIELDS.YIELD_CALCULATOR.COUNT_PLANTS_BOTON.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BUTTON_QUADRANT_BOTON.headerName,
      field: FIELDS.YIELD_CALCULATOR.BUTTON_QUADRANT_BOTON.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BUTTON_PLANT_BOTON.headerName,
      field: FIELDS.YIELD_CALCULATOR.BUTTON_PLANT_BOTON.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.FINAL_BUTTON_BOTON.headerName,
      field: FIELDS.YIELD_CALCULATOR.FINAL_BUTTON_BOTON.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BUTTON_SIMPLE_QUADRANT_BOTON.headerName,
      field: FIELDS.YIELD_CALCULATOR.BUTTON_SIMPLE_QUADRANT_BOTON.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BUTTON_ARM_QUADRANT_BOTON.headerName,
      field: FIELDS.YIELD_CALCULATOR.BUTTON_ARM_QUADRANT_BOTON.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BUTTON_DEFORMED_QUADRANT_BOTON.headerName,
      field: FIELDS.YIELD_CALCULATOR.BUTTON_DEFORMED_QUADRANT_BOTON.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BUTTON_SIMPLE_PLANT_BOTON.headerName,
      field: FIELDS.YIELD_CALCULATOR.BUTTON_SIMPLE_PLANT_BOTON.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BUTTON_ARM_PLANT_BOTON.headerName,
      field: FIELDS.YIELD_CALCULATOR.BUTTON_ARM_PLANT_BOTON.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.BUTTON_DEFORMED_PLANT_BOTON.headerName,
      field: FIELDS.YIELD_CALCULATOR.BUTTON_DEFORMED_PLANT_BOTON.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.FINAL_BUTTON_SIMPLE_BOTON.headerName,
      field: FIELDS.YIELD_CALCULATOR.FINAL_BUTTON_SIMPLE_BOTON.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.FINAL_BUTTON_ARM_BOTON.headerName,
      field: FIELDS.YIELD_CALCULATOR.FINAL_BUTTON_ARM_BOTON.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.FINAL_FRUIT_FORMED_FRUTO_FORMADO.headerName,
      field: FIELDS.YIELD_CALCULATOR.FINAL_FRUIT_FORMED_FRUTO_FORMADO.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
    createColumnDef({
      headerName: FIELDS.YIELD_CALCULATOR.EXPORT_PERCENTAGE.headerName,
      field: FIELDS.YIELD_CALCULATOR.EXPORT_PERCENTAGE.field,
      dataType: "number",
      allowEmpty: true,
      editable: true,
      suppressFillHandle: false,
      handleClickAlert,
    }),
  ];

  // funcion para limpiar las celdas editadas
  const clearEditedCells = () => {
    handleSubmit(onSubmit)();
    // const updatedRowData = rowData.map((row) => {
    //   const updatedRow = { ...row };
    //   Object.keys(updatedRow).forEach((key) => {
    //     if (key.startsWith('edited_')) {
    //       delete updatedRow[key];
    //     }
    //   });
    //   return updatedRow;
    // });

    // console.log(rowData, '<<<<<-------------------rowData');

    // const transaction = {
    //   update: rowData.map((row) => {
    //     const updatedRow = { ...row };
    //     Object.keys(updatedRow).forEach((key) => {
    //       if (key.startsWith("edited_")) {
    //         delete updatedRow[key];
    //       }
    //     });
    //     return updatedRow;
    //   }),
    // };

    // // console.log(transaction, '<<<<<-------------------transaction');

    // gridApiRef.current.applyTransaction(transaction);

    // // setRowData(updatedRowData);
    // // gridApiRef.current.setRowData(updatedRowData);
  };

  // función para setear el fullScreen
  const setFullScreen = (fullScreenState) => {
    if (fullScreenState) {
      // document.body.style.overflow = 'hidden';

      setTableContainerStyleState({
        width: "100%",
        zIndex: 1250,
        top: 0,
        left: 0,
        position: "fixed",
        overflow: "auto",
        height: "100vh",
      });

      setTableStyleState({
        height: "calc(100vh - 90px)",
      });
    } else {
      document.body.style.overflow = "";
      setTableContainerStyleState({
        // height: '80vh',
        width: "100%",
        minHeight: 800,
      });

      setTableStyleState({
        height: 700,
      });
    }
    setFullScreenState((prevState) => !prevState);
  };

  // confirma si debe tener master row, si tiene datos internos
  // const isRowMaster = useCallback((dataItem) => {
  //   return dataItem ? dataItem.variantDetails.length > 0 : false;
  // }, []);

  // genera el sidebar Custom
  const sideBar = {
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
        toolPanelParams: {
          suppressPivotMode: true, // desactivar el modo pivot
          suppressRowGroups: true, // desactivar la agrupación de filas
          suppressValues: true, // desactivar los valores
          suppressColumnFilter: false, // desactivar el filtro de busqueda en las columnas
          contractColumnSelection: true, // contraer la selección de columnas al incio
          suppressColumnSelectAll: true,
          suppressColumnExpandAll: false,
        },
        minWidth: 225,
        maxWidth: 300,
        width: 280,
      },
      // {
      // 	id: 'custom',
      // 	labelDefault: 'Personalizadas',
      // 	labelKey: 'customStats',
      // 	iconKey: 'columns',
      // 	toolPanel: customPanel,
      // 	toolPanelParams: {},
      // },

      // {
      //     id: 'filters',
      //     labelDefault: 'Filters',
      //     labelKey: 'filters',
      //     iconKey: 'filter',
      //     toolPanel: 'agFiltersToolPanel',
      //     minWidth: 180,
      //     maxWidth: 400,
      //     width: 250
      // }
    ],
    position: "right",
    //   defaultToolPanel: 'customPanel',
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const onBtnExportCsv = () => {
    if (gridApiRef.current) {
      const date = new Date();
      const formattedDate = `${String(date.getDate()).padStart(
        2,
        "0"
      )}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`; // DD-MM-YYYY
      const formattedTime = date.toTimeString().slice(0, 8).replace(/:/g, "-"); // HH-MM-SS

      const docName = dashAdd(titleCheckState);

      const fileName = `${docName}_${formattedDate}_${formattedTime}.csv`;

      gridApiRef.current.exportDataAsExcel({
        fileName: fileName,
        processCellCallback: (params) => {
          const value = params.value;
          return typeof value === "string" ? value.toUpperCase() : value;
        },
      });
    }
    handleMenuClose();
  };

  const onBtnExportExcel = () => {
    if (gridApiRef.current) {
      const date = new Date();
      const formattedDate = `${String(date.getDate()).padStart(
        2,
        "0"
      )}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`; // DD-MM-YYYY
      const formattedTime = date.toTimeString().slice(0, 8).replace(/:/g, "-"); // HH-MM-SS

      const docName = dashAdd(titleCheckState);

      const fileName = `${docName}_${formattedDate}_${formattedTime}.xlsx`;

      gridApiRef.current.exportDataAsExcel({
        fileName: fileName,
        processCellCallback: (params) => {
          const value = params.value;
          return typeof value === "string" ? value.toUpperCase() : value;
        },
      });
    }
    handleMenuClose();
  };

  // funcion para edición de celdas
  const onCellValueChanged = (params) => {
    handleCellValueChanged(params, {
      setRowData,
      rowData,
      alertRef,
      setCopyButtonState,
      markEmptyAsEdited: false,
    });
  };

  const filterEditedRows = (array) => {
    return array.filter((item) =>
      Object.keys(item).some((key) => key.startsWith("edited_"))
    );
  };

  const convertRowDataToCells = (rowData) => {
    let result = [];

    const editedRows = filterEditedRows(rowData);
    editedRows.forEach((entry) => {
      const {
        season,
        idUnitProductive,
        specieValue,
        arms,
        dartPrePoda,
        dartPrePodaExcel,
        dartPostPoda,
        dartPostPodaExcel,
        twigPrePoda,
        twigPrePodaExcel,
        twigPostPoda,
        twigPostPodaExcel,
        flowersDart,
        budDart,
        disbudding,
        flowersTwig,
        frostDart,
        frostTwig,
        fruitsDartMax,
        fruitDropRateObjective,
        boxHaReal,
        exportPercentageReal,
        fruitsetEstimate,
        yieldKilosTarget,
        fruitsPlantPreRaleo,
        fruitsPlantPreRaleoExcel,
        fruitsPlantPostRaleo,
        fruitsPlantPostRaleoExcel,
        guidelineThinning,
        caliberEstimate,
        caliberReal,
        yieldReal,
        dateStartHarvest,
        dateEndHarvest,
        brindillaPrePoda,
        brindillaPrePodaExcel,
        brindillaPostPoda,
        brindillaPostPodaExcel,
        flowersBrindilla,
        twigObjective,
        caliberObjective,
        boxHaObjective,
        fruitsTwigObjective,
        plantsHaProductive,
        exportPercentageEstimate,
        finalChargesPrePoda,
        finalChargesPostPoda,
        finalChargesPostAmarre,
        finalChargesPrePodaExcel,
        finalChargesPostPodaExcel,
        finalChargesPostAmarreExcel,
        finalBudPrePoda,
        finalBudPostPoda,
        finalBudPostAmarre,
        finalBudPrePodaExcel,
        finalBudPostPodaExcel,
        finalBudPostAmarreExcel,
        caliberObjectiveEquivalent,
        caliberRealEquivalent,
        budSproutsReal,
        budSetReal,
        fertilityReal,
        budSproutsObjective,
        budSetObjective,
        fertilityObjective,
        productionCoeffObjective,
        productionCoeffReal,
        yieldSeek,
        frostDamage,
        countPlantsBrotacion,
        countQuadrantBrotacion,
        sproutsPlantBrotacion,
        sproutsQuadrantBrotacion,
        finalSproutsBrotacion,
        sproutsWithFruitQuadrantBoton,
        sproutsWithFruitPlantBoton,
        finalSproutsWithFruitBoton,
        countQuadrantSproutsWithOutFruitBoton,
        countPlantsSproutsWithOutFruitBoton,
        finalSproutsWithOutFruitBoton,
        sproutsBrotacionHa,
        countQuadrantBoton,
        countPlantsBoton,
        buttonQuadrantBoton,
        buttonPlantBoton,
        finalButtonBoton,
        buttonSimpleQuadrantBoton,
        buttonArmQuadrantBoton,
        buttonDeformedQuadrantBoton,
        buttonSimplePlantBoton,
        buttonArmPlantBoton,
        buttonDeformedPlantBoton,
        finalButtonSimpleBoton,
        finalButtonArmBoton,
        finalButtonDeformedBoton,
        buttonBotonHa,
        finalFruitFormedFrutoFormado
      } = entry;

      result.push({
        season,
        idUnitProductive,
        specieValue,
        arms,
        dartPrePoda,
        dartPrePodaExcel,
        dartPostPoda,
        dartPostPodaExcel,
        twigPrePoda,
        twigPrePodaExcel,
        twigPostPoda,
        twigPostPodaExcel,
        flowersDart,
        budDart,
        disbudding,
        flowersTwig,
        frostDart,
        frostTwig,
        fruitsetEstimate,
        yieldKilosTarget,
        boxHaReal,
        exportPercentageReal,
        fruitsPlantPreRaleo,
        fruitsPlantPreRaleoExcel,
        fruitsPlantPostRaleo,
        fruitsDartMax,
        fruitDropRateObjective,
        fruitsPlantPostRaleoExcel,
        guidelineThinning,
        caliberEstimate,
        caliberReal,
        yieldReal,
        dateStartHarvest,
        dateEndHarvest,
        brindillaPrePoda,
        brindillaPrePodaExcel,
        brindillaPostPoda,
        brindillaPostPodaExcel,
        flowersBrindilla,
        twigObjective,
        caliberObjective,
        boxHaObjective,
        fruitsTwigObjective,
        plantsHaProductive,
        exportPercentageEstimate,
        finalChargesPrePoda,
        finalChargesPostPoda,
        finalChargesPostAmarre,
        finalChargesPrePodaExcel,
        finalChargesPostPodaExcel,
        finalChargesPostAmarreExcel,
        finalBudPrePoda,
        finalBudPostPoda,
        finalBudPostAmarre,
        finalBudPrePodaExcel,
        finalBudPostPodaExcel,
        finalBudPostAmarreExcel,
        caliberObjectiveEquivalent,
        caliberRealEquivalent,
        budSproutsReal,
        budSetReal,
        fertilityReal,
        budSproutsObjective,
        budSetObjective,
        fertilityObjective,
        productionCoeffObjective,
        productionCoeffReal,
        yieldSeek,
        frostDamage,
        countPlantsBrotacion,
        countQuadrantBrotacion,
        sproutsPlantBrotacion,
        sproutsQuadrantBrotacion,
        finalSproutsBrotacion,
        sproutsWithFruitQuadrantBoton,
        sproutsWithFruitPlantBoton,
        finalSproutsWithFruitBoton,
        countQuadrantSproutsWithOutFruitBoton,
        countPlantsSproutsWithOutFruitBoton,
        finalSproutsWithOutFruitBoton,
        sproutsBrotacionHa,
        countQuadrantBoton,
        countPlantsBoton,
        buttonQuadrantBoton,
        buttonPlantBoton,
        finalButtonBoton,
        buttonSimpleQuadrantBoton,
        buttonArmQuadrantBoton,
        buttonDeformedQuadrantBoton,
        buttonSimplePlantBoton,
        buttonArmPlantBoton,
        buttonDeformedPlantBoton,
        finalButtonSimpleBoton,
        finalButtonArmBoton,
        finalButtonDeformedBoton,
        buttonBotonHa,
        finalFruitFormedFrutoFormado
      });
    });

    return result;
  };

  const handleClosePrompt = () => {
    // setSuccessSubmitState(false);
    setConfirmPromptState(false);
  };

  const onResetSearch = () => {
    setQuickFilterText("");
  };

  const onAcceptPrompt = async () => {
    // onSaveData();
    setLoadingSubmitState(true);

    const newArray = convertRowDataToCells(rowData);

    if (newArray.length === 0) {
      setLoadingSubmitState(false);
      handleClosePrompt();
      return;
    }

    const dataObj = {
      userId: userId,
      input: newArray,
    };

    try {
      const response = await axiosContext.authAxios.post(
        endPointNamePost,
        dataObj
      );

      const { status } = response;

      if (status === 200) {
        setSuccessSubmitState(true);
        alertRef.current = false;
        setCopyButtonState(false);

        clearEditedCells();
      }
    } catch (error) {
    } finally {
      setLoadingSubmitState(false);
      handleClosePrompt();
    }
  };

  const onSaveData = async () => {
    // setLoadingSubmitState(true);
    clearFocusSelection();
  };

  const closeHandler = () => {
    setSuccessSubmitState(false);
  };

  const onCloseSnack = () => {
    // setSuccessSubmitState(false);
    handleClosePrompt();
  };

  const handleCloseDialog = () => {
    setOpenDialogState(false);
  };

  const handleCloseAndConfirmDialog = () => {
    setCopyButtonState(false);
    alertRef.current = false;
    handleSubmit(onSubmit)();

    setOpenDialogState(false);
  };

  // filter
  const getFilterAsync = useCallback(async () => {
    setLoadingFilterDataState(true);
    try {
      let response = await axiosContext.authAxios.get(endPointFilterName);

      const { data, status } = response;

      if (status === 200) {
        setFilterOptionsState(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingFilterDataState(false);
    }
  }, [axiosContext, setLoadingFilterDataState, setFilterOptionsState]);

  useEffect(() => {
    getFilterAsync();
  }, []);

  useEffect(() => {
    if (filterOptionsState) {
      setClientOptionsState(
        alterArrayAddLabels(filterOptionsState, ["clientValue", "client"])
      );
    }
  }, [filterOptionsState]);

  useEffect(() => {
    if (watchClient) {
      setValue("orchard", "");
      setOrchardsOptionsState(
        alterArrayAddLabels(watchClient?.orchards, ["orchardValue", "orchard"])
      );
    } else {
      setValue("orchard", "");
      setOrchardsOptionsState([]);
    }
  }, [setValue, watchClient]);

  useEffect(() => {
    if (watchOrchard) {
      setValue("seasonSince", "");
      setValue("seasonUntil", "");
      if (!watchOrchard?.seasons) return;
      const seasonsOptions = watchOrchard?.seasons.map((item) => {
        return {
          value: item,
          label: item,
        };
      });

      setSeasonOptionsState(seasonsOptions);
    } else {
      setValue("seasonSince", "");
      setValue("seasonUntil", "");
      setSeasonOptionsState([]);
    }
  }, [setValue, watchOrchard]);

  // PRUEBA ONLINE
  // useEffect(() => {
  // 	const data = YIELD_DATA;

  // 	setDataTableState(data);

  // 	setVisibleColumnsState(finalColumns);

  // 	const rowDataFullTransform = processDataRowDetailFull(data);

  // 	setRowData(rowDataFullTransform);

  // 	setLoadingSubmitFilterState(false);
  // }, []);
  // si hay orchard lo selecciona
  useEffect(() => {
    if (clientOptionsState.length) {
      const found = clientOptionsState.find(
        (element) => element.value === client_filter
      );

      // console.log(found, '---found');
      if (found) {
        setValue("client", found);
      } else {
        setValue("client", "");
        setValue("orchard", "");
        setValue("seasonSince", "");
        setValue("seasonUntil", "");
      }
    }

    // console.log('se ejecuta usf incial');
  }, [clientOptionsState]);

  // si hay orchard lo selecciona
  useEffect(() => {
    if (orchardsOptionsState.length) {
      const found = orchardsOptionsState.find(
        (item) => item.value === orchard_filter
      );

      if (found) {
        setValue("orchard", found);
      } else {
        setValue("orchard", "");
        setValue("seasonSince", "");
        setValue("seasonUntil", "");
      }
    }
    // console.log('se ejecuta usf incial');
  }, [orchardsOptionsState]);

  useEffect(() => {
    if (seasonOptionsState.length) {
      const foundSince = seasonOptionsState.find(
        (item) => item.value === season_since_filter
      );

      const foundUntil = seasonOptionsState.find(
        (item) => item.value === season_until_filter
      );

      if (foundSince) {
        setValue("seasonSince", foundSince);
      } else {
        setValue("seasonSince", "");
        setValue("seasonUntil", "");
      }

      if (foundUntil) {
        setValue("seasonUntil", foundUntil);
      } else {
        setValue("seasonUntil", "");
      }
    }
  }, [seasonOptionsState]);

  return (
    <div className="form-style">
      <BsContainer fluid class="px-0 px-md-3">
        <BsRow class="no-gutters">
          <BsCol class="col-md-12">
            <Card elevation={0}>
              <CardHeaderWidget
                title={viewsTexts.titles.bdcollection.yieldcalculator.title}
                subheader={<BreadCrumbs subTitle="" />}
              />
              <CardContent
                sx={{
                  paddingX: 0,
                  paddingTop: 0,
                  paddingBottom: "0 !important",
                }}
              >
                {/* PARA AVISAR DATOS NO GUARDADOS */}
                <>
                  {/* para avisar número mayores de 99999 */}
                  {errorDataState && (
                    <>
                      <Snackbar
                        open={openWarningState}
                        autoHideDuration={6000}
                        onClose={handleCloseWarningAlert}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "center",
                        }}
                        style={{ top: "18vh" }} // Aquí es donde la magia sucede
                      >
                        <Alert
                          onClose={handleCloseWarningAlert}
                          severity="warning"
                          variant="filled"
                          sx={{
                            width: "100%",
                            fontSize: 18,
                          }}
                        >
                          {`${errorDataState.field}:  ${errorDataState.message}`}
                        </Alert>
                      </Snackbar>
                      <Snackbar
                        open={openErrorState}
                        autoHideDuration={6000}
                        onClose={handleCloseErrorAlert}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "center",
                        }}
                        style={{ top: "25vh" }} // Aquí es donde la magia sucede
                      >
                        <Alert
                          onClose={handleCloseErrorAlert}
                          severity="error"
                          variant="filled"
                          sx={{
                            width: "100%",
                            fontSize: 18,
                          }}
                        >
                          VALOR INGRESADO MAYOR
                        </Alert>
                      </Snackbar>
                    </>
                  )}
                  <FormPrompt hasUnsavedChanges={copyButtonState} />
                  <Dialog
                    open={openDialogState}
                    keepMounted
                    onClose={handleCloseDialog}
                    aria-describedby="alert-dialog-slide-description"
                    className="max-w-md mx-auto"
                  >
                    <DialogContent>
                      <DialogContentText
                        id="alert-dialog-slide-description"
                        className="font-medium"
                      >
                        Tienes cambios sin guardar. Si continúas, se perderán
                        los datos editados.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions className="py-4 mr-2">
                      <Button onClick={handleCloseDialog}>Cancelar</Button>
                      <Button
                        onClick={handleCloseAndConfirmDialog}
                        variant="contained"
                        color="error"
                      >
                        Continuar sin guardar
                      </Button>
                    </DialogActions>
                  </Dialog>
                  <BsRow class="no-gutters">
                    <BsCol class="col-md-12">
                      <div style={tableContainerStyleState}>
                        {errors.incorrectDates && (
                          <p
                            style={{
                              color: theme.palette.error.main,
                              marginLeft: 10,
                            }}
                          >
                            {errors.incorrectDates.message}
                          </p>
                        )}
                        <div
                          // className='d-flex justify-content-between pb-3 pt-2'
                          className="d-flex flex-column flex-md-row justify-content-md-between justify-content-center pb-3 pt-2 gap-3"
                          style={{
                            backgroundColor: "white",
                          }}
                        >
                          <Box
                            sx={{
                              justifyContent: "flex-start",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <form
                              className="form-inline"
                              autoComplete="on"
                              onSubmit={handleSubmit(onSubmit)}
                            >
                              <div className="input-group ml-md-2">
                                <SelectMultipleWidget2
                                  errors={errors.client}
                                  loading={loadingFilterDataState}
                                  control={control}
                                  menuPortalTarget={document.body}
                                  labeltext=""
                                  name="client"
                                  display="vertical"
                                  variant="outlined"
                                  // minheight={
                                  // 	false
                                  // }
                                  isClearable={true}
                                  isSearchable
                                  // onChange={handleClearSpecieValue}
                                  isMulti={false}
                                  req={true}
                                  defaultValue=""
                                  options={clientOptionsState}
                                  placeholder="Cliente"
                                />
                              </div>
                              <div className="input-group ml-md-2">
                                <SelectMultipleWidget2
                                  errors={errors.orchard}
                                  loading={loadingFilterDataState}
                                  control={control}
                                  menuPortalTarget={document.body}
                                  labeltext=""
                                  name="orchard"
                                  display="vertical"
                                  variant="outlined"
                                  // minheight={
                                  // 	false
                                  // }
                                  isClearable={true}
                                  isSearchable
                                  // onChange={handleClearSpecieValue}
                                  isMulti={false}
                                  req={true}
                                  defaultValue=""
                                  options={orchardsOptionsState}
                                  placeholder="Huerto"
                                />
                              </div>
                              <div className="input-group ml-md-2">
                                <SelectMultipleWidget2
                                  errors={errors.seasonSince}
                                  loading={loadingFilterDataState}
                                  control={control}
                                  menuPortalTarget={document.body}
                                  labeltext=""
                                  name="seasonSince"
                                  display="vertical"
                                  variant="outlined"
                                  // minheight={
                                  // 	false
                                  // }
                                  isClearable={true}
                                  isSearchable
                                  // onChange={handleClearSpecieValue}
                                  isMulti={false}
                                  req={false}
                                  defaultValue=""
                                  options={seasonOptionsState}
                                  placeholder="Temp. Desde"
                                />
                              </div>
                              <div className="input-group ml-md-2">
                                <SelectMultipleWidget2
                                  errors={errors.seasonUntil}
                                  loading={loadingFilterDataState}
                                  control={control}
                                  menuPortalTarget={document.body}
                                  labeltext=""
                                  name="seasonUntil"
                                  display="vertical"
                                  variant="outlined"
                                  // minheight={
                                  // 	false
                                  // }
                                  isClearable={true}
                                  isSearchable
                                  // onChange={handleClearSpecieValue}
                                  isMulti={false}
                                  req={false}
                                  defaultValue=""
                                  options={seasonOptionsState}
                                  placeholder="Temp. Hasta"
                                />
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  alignSelf: "flex-start",
                                  paddingTop: 5,
                                }}
                              >
                                <SaveAction
                                  title="Filtrar"
                                  color="secondary"
                                  size="medium"
                                  className="roundedButton ml-md-2"
                                  variant="contained"
                                  disabled={loadingSubmitFilterState}
                                  messageType="add"
                                  mutationLoading={loadingSubmitFilterState}
                                  success={false}
                                />
                              </div>
                            </form>
                          </Box>
                          <Box
                            sx={{
                              // marginRight: 2,
                              marginBottom: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              gap: 2,
                            }}
                          >
                            <TextField
                              variant="outlined"
                              placeholder="Buscar..."
                              label="Buscar"
                              size="small"
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <SearchIcon />
                                  </InputAdornment>
                                ),
                                endAdornment: quickFilterText ? (
                                  <IconButton
                                    color="primary"
                                    aria-label="clear"
                                    component="span"
                                    onClick={() => onResetSearch()}
                                  >
                                    <ClearIcon
                                      fontSize="small"
                                      style={{
                                        color: theme.palette.grey[400],
                                      }}
                                    />
                                  </IconButton>
                                ) : null,
                              }}
                              value={quickFilterText}
                              onChange={handleQuickFilterChange}
                              sx={{
                                width: 200,
                              }}
                            />
                          </Box>
                          <Box>
                            <ButtonAction
                              labelButton="GUARDAR"
                              color="secondary"
                              size="large"
                              actionOnClick={onSaveData}
                              className="roundedButton"
                              variant="contained"
                              messageType="add"
                              actionClose={closeHandler}
                              fullWidth
                              disabled={
                                loadingSubmitFilterState ||
                                !rowData ||
                                !rowData.length
                              }
                              mutationLoading={loadingSubmitState}
                              success={successSubmitState}
                            />
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 2,
                            }}
                          >
                            <IconButton
                              color="primary"
                              aria-label="export"
                              onClick={handleMenuOpen}
                              disabled={
                                loadingSubmitFilterState || rowData.length === 0
                              }
                            >
                              <DownloadIcon />
                            </IconButton>
                            <Menu
                              anchorEl={anchorEl}
                              open={Boolean(anchorEl)}
                              onClose={handleMenuClose}
                            >
                              <MenuItem onClick={onBtnExportExcel}>
                                Exportar a Excel
                              </MenuItem>
                              <MenuItem onClick={onBtnExportCsv}>
                                Exportar a CSV
                              </MenuItem>
                            </Menu>
                            <IconButton
                              color="primary"
                              aria-label="fullscreen-toggle"
                              onClick={() => setFullScreen(!fullScreenState)}
                              disabled={loadingSubmitFilterState}
                            >
                              {fullScreenState ? (
                                <FullscreenExitIcon />
                              ) : (
                                <FullscreenIcon />
                              )}
                            </IconButton>
                          </Box>
                        </div>

                        {confirmPromptState ? (
                          <Dialog
                            open={confirmPromptState}
                            onClose={(event, reason) => {
                              if (reason && reason === "backdropClick") {
                                return;
                              }
                              handleClosePrompt();
                            }}
                            disableEscapeKeyDown
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                          >
                            <DialogTitle
                              id="alert-dialog-title"
                              sx={{
                                lineHeight: 0.5,
                              }}
                            >
                              Edición {titleModule}
                            </DialogTitle>
                            <DialogContent>
                              <DialogContentText
                                id="alert-dialog-description"
                                className={classes.dialogTextStyle}
                              >
                                ¿Confirma que desea actualizar los datos?
                              </DialogContentText>
                            </DialogContent>
                            <DialogActions
                              sx={{
                                justifyContent: "space-between",
                              }}
                            >
                              <Button
                                onClick={handleClosePrompt}
                                disabled={loadingSubmitState}
                                sx={{
                                  color: theme.palette.grey[500],
                                }}
                              >
                                Cancelar
                              </Button>
                              <ButtonAction
                                labelButton="GUARDAR"
                                color="secondary"
                                // size='large'
                                actionClose={onCloseSnack}
                                variant="contained"
                                fullWidth={true}
                                actionOnClick={onAcceptPrompt}
                                disabled={false}
                                messageType="edit"
                                mutationLoading={loadingSubmitState}
                                success={false}
                              />
                            </DialogActions>
                          </Dialog>
                        ) : null}
                        <Alert
                          severity={"info"}
                          variant="outlined"
                          className="mb-3"
                        >
                          <AlertTitle>Información Sobre Conteos</AlertTitle>
                          <p>
                            Los campos Dardos, Ramillas y Frutos solo son
                            editables mientras no contengan conteos
                          </p>
                        </Alert>
                        {loadingSubmitFilterState && <LoadingWidget />}
                        {!loadingSubmitFilterState &&
                          (dataTableState && dataTableState?.length ? (
                            <div
                              className="ag-theme-quartz"
                              style={tableStyleState}
                            >
                              <AgGridReact
                                rowData={rowData}
                                processCellForClipboard={(cell) => {
                                  if (cell.value === null) {
                                    return "";
                                  }
                                  return handleChangeCellClipboard(cell.value);
                                }}
                                columnDefs={visibleColumnsState}
                                onCellValueChanged={onCellValueChanged}
                                pagination={true}
                                paginationPageSize={50}
                                suppressMovableColumns={true}
                                suppressDragLeaveHidesColumns={true}
                                paginationPageSizeSelector={
                                  paginationPageSizeSelector
                                }
                                localeText={localeText}
                                defaultColDef={{
                                  resizable: true,
                                  minWidth: 200, // Ancho mínimo
                                  floatingFilter: true,
                                  filter: false,
                                }}
                                //   masterDetail={true}
                                //   detailCellRendererParams={
                                //     detailCellRendererParams
                                //   }
                                groupDisplayType={"multipleColumns"}
                                rowGroupPanelShow={"always"}
                                enableRangeSelection={true}
                                enableFillHandle={true}
                                quickFilterText={quickFilterText}
                                onGridReady={onGridReady}
                                sideBar={sideBar}
                                embedFullWidthRows={true}
                                // isRowMaster={isRowMaster}
                                // detailRowAutoHeight={true}
                                getRowId={(params) => params.data.id}
                                // grandTotalRow={'bottom'}
                              />
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "70vh",
                                width: "100%",
                              }}
                            >
                              <Typography variant="h5" color="textSecondary">
                                No hay datos
                              </Typography>
                            </div>
                          ))}
                      </div>
                    </BsCol>
                  </BsRow>
                </>
              </CardContent>
            </Card>
          </BsCol>
        </BsRow>
      </BsContainer>
    </div>
  );
};

export default YieldCalculator;
